import { createFileRoute, notFound } from "@tanstack/react-router";
import type { JSX } from "react";

import { parseReturnSearch, ReturnsPage, type ReturnFilters } from "@/features/orders";
import { isFeatureEnabled } from "@/shared/lib/feature-flags";

function ReturnsRoute(): JSX.Element {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <ReturnsPage
      urlFilter={search}
      onUrlFilterChange={(next) => void navigate({ search: next, replace: true })}
    />
  );
}

export const Route = createFileRoute("/_authenticated/returns")({
  // Cast is safe under current URL semantics: each param appears at most once,
  // so TanStack's raw record values are strings (or absent) here.
  validateSearch: (raw: Record<string, unknown>): ReturnFilters => parseReturnSearch(raw),
  beforeLoad: () => {
    // Shown by default; set PUBLIC_FEATURE_HIDE_RETURNS=true to hide.
    // The sidebar entry is hidden by the same flag, this guards direct navigation.
    if (isFeatureEnabled("hide_returns")) throw notFound();
  },
  component: ReturnsRoute,
});
